import { styled } from 'styled-components';

export const BannerContainer = styled.div<{ visible: boolean }>`
  display: ${({ visible }) => visible ? 'block' : 'none'};
  background: #1D9E75;
  color: #fff;
  text-align: center;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #178563;
  }
`;
